import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppHttpErrorInterceptor } from './app-http-error.interceptor';

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AppHttpErrorInterceptor,
    multi: true,
  },
];
